<template>
  <div>
    <b-loading :active.sync="loadingInicial" />
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="CRM PJ E PF" />

      <v-btn
        color="#031127"
        style="border-radius: 25px"
        dark
        small
        @click.native="fetchCrm"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12" md="3" lg="3">
        <Lynx-Label label="Digite Id / Nome / Razão Social" />

        <label class="flex flex-col w-full">
          <input
            class="border-primary-200 bg-white px-2 border-l-4 border-solid rounded py-1 w-full transition focus:shadow focus:border-r-4 font-light"
            v-model="owners_id"
            v-on:keyup.enter="fetchCrm"
          />
        </label>
      </v-col>

      <v-col cols="12" md="3" lg="3">
        <Lynx-Label label="Selecione tipo" />
        <treeselect
          :multiple="false"
          :options="[
            { id: 0, label: 'Todos' },
            { id: 'cliente', label: 'Cliente' },
            { id: 'empresa', label: 'Empresa' },
          ]"
          placeholder="Selecione tipo"
          v-model="filtros.owner_type"
        />
      </v-col>

      <v-col cols="12" md="3" lg="3">
        <Lynx-Label label="Seleciona um período" />
        <b-datepicker
          v-model="filtros.data"
          placeholder="Seleciona um período"
          :date-parser="(date) => new Date(date)"
          :month-names="monthNames"
          :day-names="dayNames"
          :years-range="[-3, 3]"
          range
        >
          <b-button
            label="Clear"
            type="is-danger"
            icon-left="close"
            outlined
            @click="filtros.data = null"
          />
        </b-datepicker>
      </v-col>

      <v-col cols="12" md="3" lg="3">
        <Lynx-Label label="Carteiras" />
        <treeselect
          :multiple="true"
          :options="lista_carteiras"
          placeholder="Selecione as carteiras..."
          v-model="filtros.carteiras"
        />
      </v-col>
      <v-col cols="12" md="3">
        <FiltroStatus :retirarDefinitivo="true" v-model="filtros.status" />
      </v-col>
    </v-row>
    <v-row class="justify-between mb-3 pt-3">
      <v-col cols="12" md="6">
        <Crm
          :owner-type-parametro="null"
          :owner-id-parametro="null"
          :permanecer-escolher-payer="true"
        />
      </v-col>
      <v-col class="row justify-end align-center" cols="12" md="6">
        <v-btn color="primary" dark @click.native="gerarRelatorio">
          <v-icon>mdi-file-document</v-icon>
          Relatorio Crm
        </v-btn>
      </v-col>
    </v-row>

    <div cols="12" md="12" lg="12" class="table-container">
      <b-table
        class="table"
        :data="lista_crm"
        :columns="columns"
        hoverables
        :loading="loading"
        backend-pagination
        paginated
        @page-change="onPageChange"
        :total="pagination.total"
        :current-page="pagination.current_page"
        :per-page="pagination.per_page"
        :style="tamanhoTela"
      >
        <template slot-scope="props">
          <b-table-column field="owner_id">
            {{ props.row.owner_id }}
          </b-table-column>
          <b-table-column field="owner_type">
            <Icon-User v-if="props.row.owner_type === 'cliente'" />
            <Icon-Company v-if="props.row.owner_type === 'empresa'" />
          </b-table-column>
          <b-table-column field="nome">
            {{ props.row.nome }}
          </b-table-column>

          <b-table-column field="carteiras">
            <p v-for="(it, index) in props.row.carteiras" :key="index">
              {{ it.nome }}
            </p>
          </b-table-column>

          <b-table-column field="data">
            {{ formatEnToBr(props.row.data_emissao) }}
            {{ props.row.status == 5  ? "(Previsão)" : props.row.status == 6 ?  "(Solicitação)" :'' }}
          </b-table-column>

          <b-table-column width="200px" field="data_validade">
            {{ formatEnToBr(props.row.data_validade) }}
          </b-table-column>

          <b-table-column field="status">
            <StatusTipo :status="props.row.status" />
          </b-table-column>

          <!-- <b-table-column field="numero">
            {{ props.row.numero }}
          </b-table-column>
          <b-table-column field="senha">
            {{ props.row.senha }}
          </b-table-column>
          <b-table-column width="350px" field="Link">
            {{ props.row.link }}
          </b-table-column> -->
          <b-table-column width="150px" field="updated_at">
            {{ formatEnToBr(props.row.updated_at) }}
          </b-table-column>

          <b-table-column field="acoes">
            <div class="flex text-sm items-center justify-end gap-2">
              <Crm
                :owner-type-parametro="props.row.owner_type"
                :owner-id-parametro="props.row.owner_id"
                :eh-tabela="true"
                @atualizou="fetchCrm"
                :crm-id="props.row.id"
              />
              <v-btn
                v-if="hasRole('super-admin')"
                color="error"
                fab
                small
                class="bg-error-base rounded-full p-2"
                @click.native="deleteCrm(props.row.id, props.row.owner_type)"
              >
                <Icon-Trash class="text-neutral-100" size="4" />
              </v-btn>
              <Logs
                v-if="props.row.activities"
                :logs="props.row.activities"
                :loading="loading"
              />
            </div>
          </b-table-column>
        </template>
        <template #empty>
          <Not-Found-Data text="Nenhum Crm registrado" />
        </template>
      </b-table>
      <div class="float-left" style="margin-top: -80px">
        <div :class="{ 'disabled-pagination': loading }">
          <b-pagination
            :total="pagination.total"
            :current.sync="current_page"
            :per-page="pagination.per_page"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { indexCrmRequest, crmsDeleteRequest } from "@/services/requests/crms";

// import CreateCrm from "@/views/empresas/crms/Create";
import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames, dayNames } from "@/utils/utils";
import Logs from "@/views/logs/Logs";
import Treeselect from "@riophae/vue-treeselect";
import { mapGetters } from "vuex";
import Crm from "@/components/shared/Crm";
import { hasRole } from "@/utils/can";
import { formatEnToBr } from "@/utils/momentHelpers";
import StatusTipo from "@/views/components/StatusTipo.vue";
import { listaStatus } from "@/utils/enums/statusDatas";
import FiltroStatus from "@/views/components/FiltroStatus.vue";
export default {
  name: "CrmIndex",
  components: { NotFoundData, Treeselect, Logs, Crm, StatusTipo, FiltroStatus },
  data() {
    return {
      monthNames,
      dayNames,
      moment,
      loading: false,
      loadingInicial: false,
      createModal: false,
      editModal: false,
      columns: [
        { key: "owner_id", label: "ID" },
        { key: "owner_type", label: "Tipo" },
        { key: "nome", label: "Nome" },
        { key: "carteiras", label: "Carteiras" },
        { key: "data_emissao", label: "Data" },
        { key: "data_validade", label: "Data de validade" },
        { key: "status", label: "Status" },
        // { key: "numero", label: "Numero" },
        // { key: "senha", label: "Senha" },
        // { key: "link", label: "Link" },
        { key: "updated_at", label: "Atualização" },
        { key: "acoes", label: "Ações" },
      ],
      listaStatus,
      crms: {
        data: [],
        pagination: {
          current_page: 1,
          per_page: 10,
          total: 0,
        },
      },
      currentCrm: null,
      carteira: null,
      carteiras: [],
      status_crm: null,
      owners_id: null,

      filtros: {
        page: 1,
        perPage: 10,
        empresa_id: null,
        carteiras: null,
        status: null,
        owner_id: null,
        owner_type: null,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
    };
  },
  filters: {},
  watch: {
    "filtros.perPage"() {
      this.fetchCrm();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.fetchCrm();
    },
  },
  computed: {
    ...mapGetters(["getToken"]),

    lista_carteiras() {
      //  return this.$store.state.carteira.lista_carteiras;
      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [{ id: 0, label: "todas" }];
      for (let i = 0; i < carteira.length; i++) {
        data.push({ id: carteira[i].id, label: carteira[i].nome });
      }
      return data;
    },
    lista_crm() {
      return this.crms.data;
    },
    pagination() {
      return this.crms.pagination;
    },
    tamanhoTela() {
      const tamanhoFixo = 2000;
      const larguraTela =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const tamanhoRelativo = (tamanhoFixo / larguraTela) * 100;
      const tamanhoFinal = tamanhoRelativo;
      return `width:${tamanhoFinal}vw;`;
    },
  },

  methods: {
    hasRole,
    formatEnToBr,
    listar_carteiras() {
      this.$store.dispatch("carteira/listar_carteiras");
    },

    fetchCrm() {
      this.loading = true;

      if (this.owners_id) {
        this.filtros.owner_id = this.owners_id.split(",");
      } else {
        this.filtros.owner_id = null;
      }

      const { filtros } = this;

      const filtrosPreenxidos = Object.keys(filtros).reduce((acc, key) => {
        if (this.filtros[key] !== 0) {
          acc[key] = this.filtros[key];
        }
        return acc;
      }, {});

      indexCrmRequest(filtrosPreenxidos)
        .then((res) => (this.crms = res.data))
        .finally(() => (this.loading = false));
    },
    openCreateModal() {
      this.$snack.success("Em breve");
      // this.createModal = true;
    },
    openEditModal(currentCrm) {
      this.currentCrm = currentCrm;
      this.editModal = true;
    },
    onEditCrm() {
      this.fetchCrm();
      this.editModal = false;
    },
    onCreateCrm() {
      this.fetchCrm();
      this.createModal = false;
    },
    deleteCrm(id, tipo) {
      this.$buefy.dialog.confirm({
        message:
          "Deseja realmente excluir o crm " +
          (tipo == "empresa" ? "desta empresa" : "deste cliente"),
        confirmText: "Excluir",
        cancelText: "Cancelar",
        type: "is-danger",
        onConfirm: () => this.onDeleteCrm(id),
      });
    },
    onDeleteCrm(id) {
      crmsDeleteRequest(id)
        .then(() => {
          this.$snack.success("Crm excluido com sucesso");
          this.fetchCrm();
        })
        .catch(() => this.$snack.error("Não foi possivel excluir o alvará"));
    },
    gerarRelatorio() {
      const { filtros } = this;

      const filtrosPreenxidos = Object.keys(filtros).reduce((acc, key) => {
        if (this.filtros[key] !== 0 && this.filtros[key] !== null) {
          acc[key] = this.filtros[key];
        }
        return acc;
      }, {});
      let form = {
          ...filtrosPreenxidos,
        };
      if (this.filtros.data != null) {
         form = {
          ...filtrosPreenxidos,
          data: this.filtros.data.map((date) => date.toISOString()),
        };
      }

      // Constrói a string de parâmetros, tratando corretamente arrays
      const parametrosString = Object.entries(form)
        .flatMap(([chave, valor]) => {
          if (Array.isArray(valor)) {
            return valor.map(
              (item) =>
                `${encodeURIComponent(chave)}[]=${encodeURIComponent(item)}`
            );
          } else {
            return `${encodeURIComponent(chave)}=${encodeURIComponent(valor)}`;
          }
        })
        .join("&");

      const baseUrl = `${process.env.VUE_APP_API_URL}/crms/relatorio`;

      // Monta a URL completa incluindo o token e abre em uma nova aba
      const urlCompleta = `${baseUrl}?${parametrosString}&token=${this.getToken}`;
      window.open(urlCompleta, "_blank");
    },

    onPageChange(page) {
      this.current_page = page;
    },
  },
  beforeMount() {
    this.fetchCrm();
    this.listar_carteiras();
  },
};
</script>

<style>
.disabled-pagination {
  pointer-events: none;
  opacity: 0.6;
}
</style>
